import { SearchInput } from './_input'
import { SearchFilters } from './_filters'

/**
 * Инициализирует страницу поиска.
 * Создает экземпляры SearchInput и SearchFilters для управления функциональностью поиска.
 */
export function initSearchPage() {
  const searchContainer = document.querySelector<HTMLElement>(
    '[data-search-results]'
  )
  if (!searchContainer) return

  const inputContainer = searchContainer.querySelector<HTMLElement>(
    '[data-search-input]'
  )

  new SearchInput(inputContainer!, onSearchInputChange)
  new SearchFilters(searchContainer)
}

/**
 * Обрабатывает изменение значения в поле поиска.
 * Обновляет URL с параметром query и перезагружает страницу.
 * @param {string} value - Новое значение поискового запроса
 */
function onSearchInputChange(value: string) {
  const uri = new URL(window.location.href)

  if (value.length > 0) {
    uri.searchParams.set('query', value)
  } else {
    uri.searchParams.delete('query')
  }

  window.location.href = uri.toString()
}
